import { render } from "./SuggestionManagerNotesLink.vue?vue&type=template&id=78a78a7e"
import script from "./SuggestionManagerNotesLink.vue?vue&type=script&lang=js"
export * from "./SuggestionManagerNotesLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__